import React from "react";
import { Link } from "react-router-dom";

const stats = [
  { num: "5,000", label: "Years of unbroken tradition" },
  { num: "18+", label: "Years of clinical practice" },
  { num: "12,000+", label: "Patients cared for" },
  { num: "40+", label: "Classical formulations" },
];

const About = () => (
  <div data-testid="about-page">
    <section className="px-6 md:px-12 lg:px-20 pt-24 pb-16 md:pt-32">
      <p className="overline mb-6">About Ayurveda Clinic</p>
      <h1 className="text-5xl sm:text-7xl tracking-tight font-light max-w-4xl leading-[1.05]">
        A small sanctuary devoted to the <em className="font-display italic" style={{ color: "var(--ayu-secondary)" }}>oldest medicine</em> in continuous practice.
      </h1>
    </section>

    <section className="px-6 md:px-12 lg:px-20 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 pb-20">
      <div className="lg:col-span-5">
        <img src="/images/clinic_interior.png" alt="Clinic" className="w-full h-[60vh] object-cover" loading="lazy" />
      </div>
      <div className="lg:col-span-6 lg:col-start-7">
        <p className="overline mb-4">Our Story</p>
        <h2 className="text-3xl sm:text-4xl mb-6 leading-tight">Founded on a single principle.</h2>
        <p className="leading-relaxed mb-6" style={{ color: "var(--ayu-body)" }}>
          The clinic began in 2007 as a modest two-room practice above a herbal shop in Pune.
          Our founder, Vaidya Gunjan Yekhade, had returned from postgraduate years
          determined to offer Ayurveda as it was meant to be — slow, personal, and uncompromising
          in its sourcing.
        </p>
        <p className="leading-relaxed mb-6" style={{ color: "var(--ayu-body)" }}>
          Eighteen years later, we still grind most of our own herbs. We still cook our ghee on
          open wood fire. We still see fewer patients than most clinics — because depth requires
          time.
        </p>
        <p className="leading-relaxed" style={{ color: "var(--ayu-body)" }}>
          Today we are four Vaidyas, twelve trained therapists, an apothecary, and a small
          equipment workshop in Kerala. Quiet work, done well.
        </p>
      </div>
    </section>

    <section className="px-6 md:px-12 lg:px-20 py-20 md:py-32" style={{ background: "var(--ayu-surface)" }}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        {stats.map((s, i) => (
          <div key={i} data-testid={`stat-${i}`}>
            <p className="font-display text-5xl sm:text-6xl mb-2" style={{ color: "var(--ayu-primary)" }}>{s.num}</p>
            <p className="text-sm" style={{ color: "var(--ayu-body)" }}>{s.label}</p>
          </div>
        ))}
      </div>
    </section>

    <section className="px-6 md:px-12 lg:px-20 py-20 md:py-32 max-w-4xl">
      <p className="overline mb-6">What we believe</p>
      <h2 className="text-4xl sm:text-5xl mb-12 leading-tight">Four convictions that shape our work.</h2>
      <div className="space-y-12">
        {[
          { n: "01", t: "Time is the most important medicine.", d: "Healing rushed is healing undone. Most of our protocols last weeks, not days." },
          { n: "02", t: "The herb is only as good as the soil.", d: "We work directly with organic farms in MP, Kerala and Uttarakhand. We see where it grows." },
          { n: "03", t: "Texts before trends.", d: "If Charaka or Sushruta did not write it, we treat it with caution. The old books still hold the answers." },
          { n: "04", t: "Hospitality is part of healing.", d: "From the chair you sit in to the kitchen that feeds you — every detail is calibrated to the protocol." },
        ].map((b) => (
          <div key={b.n} className="grid grid-cols-12 gap-6 items-start" data-testid={`belief-${b.n}`}>
            <p className="col-span-2 font-display text-2xl" style={{ color: "var(--ayu-secondary)" }}>{b.n}</p>
            <div className="col-span-10">
              <h3 className="text-2xl mb-2">{b.t}</h3>
              <p className="leading-relaxed" style={{ color: "var(--ayu-body)" }}>{b.d}</p>
            </div>
          </div>
        ))}
      </div>
    </section>

    <section className="px-6 md:px-12 lg:px-20 py-24 text-center">
      <Link to="/doctors" data-testid="meet-doctors-cta" className="btn-primary">Meet our doctors</Link>
    </section>
  </div>
);

export default About;
